import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Sparkles, Users } from 'lucide-react';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="relative h-96 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://thepinkedit.net/cdn/shop/files/soft-blush-pink-section-background.png)'
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-pink-900/70 to-rose-900/60"></div>
        </div>
        
        <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center text-center">
          <div className="text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-4">About The Pink Edit</h1>
            <p className="text-xl md:text-2xl text-pink-100">Pretty things for powerful women</p>
          </div>
        </div>
      </div>

      {/* Our Story */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-gray-900 mb-6 text-center">Our Story</h2>
          <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
            <p>
              Welcome to The Pink Edit, where femininity meets empowerment. We believe that every woman deserves to feel confident, beautiful, and powerful in what she wears.
            </p>
            <p>
              Founded with a passion for all things pink, The Pink Edit curates thoughtfully selected pieces that celebrate the modern woman. From soft blush tones to bold fuchsia statements, our collection is designed to help you express your unique style and embrace your feminine power.
            </p>
            <p>
              We're more than just a boutique – we're a community of women who support and inspire each other. Every piece in our collection is chosen with care, ensuring quality, comfort, and that special something that makes you feel amazing.
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 bg-gradient-to-br from-pink-50 to-rose-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center">Our Values</h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
              <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <Heart className="text-pink-600" size={32} />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Quality First</h3>
              <p className="text-gray-600">
                We believe in offering only the highest quality pieces that you'll love and cherish for years to come.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
              <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <Sparkles className="text-pink-600" size={32} />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Celebrate Femininity</h3>
              <p className="text-gray-600">
                Pink isn't just a color – it's a statement of confidence, grace, and unapologetic femininity.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
              <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <Users className="text-pink-600" size={32} />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Community Driven</h3>
              <p className="text-gray-600">
                We're building a community of powerful women who lift each other up and celebrate individuality.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Statement */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Mission</h2>
          <p className="text-xl text-gray-700 leading-relaxed mb-8">
            To empower women through fashion by providing beautiful, high-quality pieces that celebrate femininity, confidence, and individual style. We're committed to making every woman feel like the powerful, beautiful person she is.
          </p>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-24 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://thepinkedit.net/cdn/shop/files/pink-summer-outfit.jpg)'
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-pink-900/80 to-rose-900/70"></div>
        </div>
        
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Ready to Find Your Perfect Pink?
          </h2>
          <p className="text-xl mb-8">
            Join our community and discover pieces that make you feel confident and beautiful.
          </p>
          <Link
            to="/collections/all"
            className="inline-block px-10 py-5 bg-white text-pink-600 rounded-full font-bold text-lg hover:bg-pink-50 transition-all transform hover:scale-105 shadow-2xl"
          >
            Shop Our Collection
          </Link>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
